import React, {Fragment, useEffect, useState} from 'react';
import ZoomMeeting from "./meeting/ZoomMeeting";
import Header from "./Header";
import Footer from "./Footer";
import Loading from "./Loading";
import HTTPClient from "../HTTPClient";
import {Link, useHistory} from "react-router-dom";
import * as axios from "axios";
import Typography from "@material-ui/core/Typography";
import {getMessage} from "../util";
import CancelIcon from '@mui/icons-material/Cancel';

import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {Grid, Radio, RadioGroup} from "@material-ui/core";
import {Stack, Box} from '@mui/material';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import {makeStyles} from "@material-ui/core/styles";
import QueueItem from "./dicoex/QueueItem";
import QueueHeader from "./dicoex/QueueHeader";
import QueueInfo from "./dicoex/QueueInfo";
import {Helmet} from "react-helmet";


const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
        alignItems: 'left',
    },
    number: {
        fontFamily: "Montserrat",
        "font-size": "1.3rem"
    },
    expanded: {
        width: '100%',
        backgroundColor: 'deepskyblue',
        color: 'antiquewhite',
        fontSize: 'large'
    }
}));

const loadMeeting = async (meeting_id, history) => {
    const meeting = await HTTPClient({
        method: "get",
        url:
            process.env.REACT_APP_API_URL +
            "/meetings/" + meeting_id
    });

    // check if open question
    const open_questions = meeting.data.questions.filter(q => {
        return (!q.url && q.state === 'open')
    });

    if (open_questions.length > 0) {
        history.push('/meeting/' + meeting.data.slug + '/questions');
    }
    return (meeting.data);
}

const Main = (props) => {

    const classes = useStyles();

    const meeting_id = props.match.params.meeting_id;

    const [loading, setLoading] = useState(false);
    const [help, setHelp] = useState(false);
    const [meeting, setMeeting] = useState(null);
    const [representative, setRepresentative] = useState(null);
    const [shares, setShares] = useState(null);
    const [hash, setHash] = useState("none");
    const [messages, setMessages] = useState(null);
    const [changeableWindow, setChangeableWindow] = useState(false);
    const [isFixed, setIsFixed] = useState(true);
    const [isRelated, setIsRelated] = useState(false);

    const [queueList, setQueueList] = useState([2, 56, 4, 3, 6, 5, 2, 77]);
    const [myTurn, setMyTurn] = useState(4);

    const site_key = process.env.REACT_APP_ENTERPRISE_RECAPTCHA_SITE;

    let history = useHistory();

    const resetLanguage = (event) => {
        localStorage.setItem('eholder-lang-' + meeting_id, event.target.value);
        messages.lang = event.target.value;
        setMessages({...messages});
    }

    const addToQueue = () => {
        const item = Math.floor(100 * Math.random());
        setQueueList(oldArray => [...oldArray, item]);
    }

    const removeFromQueue = () => {

        if (queueList.length<=1) return;

        sendMessage('atendiendo al '+ queueList[1],help);

        setQueueList(oldArray => oldArray.slice(1));
    }

    const isFixedHandler = (inputIsFixed) => {
        setIsFixed(inputIsFixed);
    }

    const handleChange = (event) => {
        if (event.target.value === 'yes')
            setIsRelated(true);
        else
            setIsRelated(false);
    }

    const setRelated = async () => {
        try {
            await HTTPClient({
                method: "put",
                url:
                    process.env.REACT_APP_API_URL +
                    '/meetings/' + meeting_id + '/related/' + isRelated
            });

            const me = await HTTPClient({
                method: "get",
                url:
                    process.env.REACT_APP_API_URL +
                    "/meetings/" + meeting_id + "/me"
            });

            setRepresentative(me.data);
        } catch (error) {
            alert('No pudo responder relacionado');
        } finally {

        }
    }

    // effect to reload meeting when changed hash
    useEffect(() => {
        (async () => {
            try {
                const meeting = await loadMeeting(meeting_id, history);
                setMeeting(meeting);
                setChangeableWindow((meeting.zoom && meeting.zoom.changeable_window) ? meeting.zoom.changeable_window : false);
                // check if open question
                const open_questions = meeting.questions.filter(q => {
                    return (!q.url && q.state === 'open')
                });
                if (open_questions.length > 0) {
                    setIsFixed(false);
                } else {
                    setIsFixed(true);
                }
            } catch (error) {
                console.log("Main.js useEffect-hash loadMeeting error: ", error);
                switch (error.response.status) {
                    case 401:
                        window.location = '/login/' + meeting_id;
                        break;
                    case 403:
                        window.location = '/meeting/' + meeting_id + '/pending';
                        break;
                    default:
                        setLoading(false);
                        break;
                }
            }
        })()
    }, [hash]);

    // effect only once
    useEffect(() => {
        setLoading(true);
        (async () => {
            try {
                // load the meeting the first time
                const meeting = await loadMeeting(meeting_id, history);
                setChangeableWindow((meeting.zoom && meeting.zoom.changeable_window) ? meeting.zoom.changeable_window : false);

                const open_questions = meeting.questions.filter(q => {
                    return (!q.url && q.state === 'open')
                });
                if (open_questions.length > 0) {
                    setIsFixed(false);
                } else {
                    setIsFixed(true);
                }
                // load messages
                if (meeting.messages) {
                    const load_messages = await axios({
                        method: "get",
                        url: meeting.messages
                    });
                    const messages = load_messages.data;
                    const nav_lang = navigator.language.split('-')[0];

                    messages.lang = messages.languages.length > 1 ? (localStorage.getItem('eholder-lang-' + meeting_id) || nav_lang) : nav_lang;
                    setMessages(messages);
                }

                //load user
                const me = await HTTPClient({
                    method: "get",
                    url:
                        process.env.REACT_APP_API_URL +
                        "/meetings/" + meeting_id + "/me"
                });

                const shares = await HTTPClient({
                    method: "get",
                    url:
                        process.env.REACT_APP_API_URL +
                        "/meetings/" + meeting_id + "/me/shares"
                });

                setShares(shares.data);
                setMeeting(meeting);
                setRepresentative(me.data);
                setLoading(false);

                const intervalId = setInterval(() => {
                    (async () => {
                        try {
                            const got_hash = await HTTPClient({
                                method: "get",
                                url:
                                    process.env.REACT_APP_API_URL +
                                    "/meetings/" + meeting_id + "/hash"
                            });
                            setHash(got_hash.data);
                        } catch (error) {
                            console.log("Main.js useEffect-meetingId hash error: ", error);
                            switch (error.response.status) {
                                case 401:
                                    window.location = '/login/' + meeting_id;
                                    break;
                                case 403:
                                    window.location = '/meeting/' + meeting_id + '/pending';
                                    break;

                                default:
                                    setLoading(false);
                                    break;
                            }
                        }
                    })();
                }, 3000);
                return (() => {
                    clearInterval(intervalId);
                });
            } catch (error) {
                console.log("Main.js useEffect-meetingId loadMeeting error: ", error);
                switch (error.response.status) {
                    case 401:
                        window.location = '/login/' + meeting_id;
                        break;
                    case 403:
                        window.location = '/meeting/' + meeting_id + '/pending';
                        break;
                    default:
                        setLoading(false);
                        break;
                }
            }
        })();
    }, [meeting_id]);


    const sendMessage = async (reason,help) => {

        const connect = async (data) =>  HTTPClient({
            method: "post",
            data: data,
            url:
                process.env.REACT_APP_API_URL +
                "/login/send_phone"
        })
            .then(response => {

            });


        if (process.env.REACT_APP_RECAPTCHA_ENABLED !== "false") {
            window.grecaptcha.enterprise.ready(async () => {
                window.grecaptcha.enterprise.execute(process.env.REACT_APP_RECAPTCHA_SITE, {action: 'id_password'}).then(async token => {
                    const data = {
                        email:  representative.identity,
                        gRecaptchaResponse: token,
                        jwt: "eyJhbGciOiJFUzI1NiIsImp3ayI6eyJrdHkiOiJFQyIsImNydiI6IlAtMjU2IiwieCI6ImJaSDdWWjVJTF95eVU0SnNELTQ1dC1WdDBNVGtvS0JsUTdfVld1bWFiNVEiLCJ5IjoiRjhfem8wQzRTRHVQUU02dmN4N1ZFUVZvYUdaNkdzVzVXWm5xRnZIbWR2TSJ9fQ.eyJzdWIiOiJjbC5ldm90aW5nLmF1dGhlbnRpY2F0ZS5ydW4iLCJyZWFzb24iOiJ3cm9uZyBwYXNzd29yZCIsImlkZW50aXR5IjoiMTA1ODIxNTgtMSIsIm1lZXRpbmdfaWQiOiJYalBhNDBOWiIsImlzcyI6ImNsLmV2b3RpbmcuYWNjaW9uaXN0YXMiLCJzdGF0ZSI6Indyb25nIiwiaWF0IjoxNjUzMDk0OTQ1fQ.D4jNyFNTDYzq4xgKugnKRgsI9LDH3coKu_uyTFYFmMo0kaDWFN2Hda-2kCxv5J38h4g3RUbqqQ9tSatuqqqPxg",
                        name: representative.name,
                        phone: "234234234",
                        reason: reason
                    }
                    await connect(data);
                })
            })
        } else {
            const data = {
                reason: 'piede ayuda',
                representative: representative
            }
            await connect(data);
        }

        setHelp(help);
    }

    return (
        <Fragment>
            {loading ? (
                <Loading/>
            ) : (

                (meeting && representative && shares) ? (
                    <Fragment>
                        {meeting.config.captcha &&
                            <Helmet>
                                <script src={"https://www.google.com/recaptcha/enterprise.js?render=" + site_key}></script>
                            </Helmet>
                        }
                        <Dialog
                            open={meeting.ask_related && (typeof representative.related === 'undefined')}
                            scroll="body"
                            onClose={props.handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">
                                {getMessage(meeting.meeting_type, 'related_title', messages)}
                            </DialogTitle>

                            <DialogContent>
                                <Box alignItems={"center"} justifyContent={"center"} display={"flex"}>
                                    <Typography>
                                        {getMessage(meeting.meeting_type, 'related', messages)}
                                    </Typography>
                                </Box>
                                <Box alignItems={"center"} justifyContent={"center"} display={"flex"}>
                                    <RadioGroup row
                                                onChange={handleChange}
                                                aria-label="relacionado"
                                                name="relacionado"
                                    >
                                        <FormControlLabel value="yes" control={<Radio/>}
                                                          label={getMessage(meeting.meeting_type, 'yes', messages)}/>
                                        <FormControlLabel value="no" control={<Radio/>}
                                                          label={getMessage(meeting.meeting_type, 'no', messages)}/>
                                    </RadioGroup>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button variant="outlined" autoFocus onClick={setRelated}>
                                    {getMessage(meeting.meeting_type, 'answer', messages)}
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Header messages={messages} user={representative} logo={meeting.logo} meeting={meeting}
                                shares={shares} resetLanguage={resetLanguage}/>
                        <hr/>
                        <Grid container spacing={1} className={classes.paper}>
                            <Grid item xs={12} sm={7}>
                                {meeting.zoom && meeting.zoom.is_integrated &&
                                    <ZoomMeeting
                                        meeting={meeting}
                                        changeableWindow={changeableWindow}
                                        isFixed={isFixed}
                                        onFixed={isFixedHandler}
                                    />
                                }
                                <br/>
                                {help ? (
                                    <Stack direction="row" spacing={2}>
                                        <Box>En breve lo contactarán para ayudarle</Box>
                                        <Box><Button variant="outlined" startIcon={<CancelIcon/>}
                                                     onClick={(event) => {event.preventDefault(); sendMessage('cancela ayuda',false)}}>
                                            Cancelar Ayuda
                                        </Button></Box>
                                    </Stack>
                                ) : (
                                    <Button className={classes.expanded} variant="contained" autoFocus
                                            onClick={(event) => {event.preventDefault(); sendMessage('pide ayuda',true)}}>
                                        Pedir Ayuda
                                    </Button>
                                )}

                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <QueueHeader number={queueList[0]} title={"Clave Única"} label={"Atendiendo a"}
                                             myTurnStyle={false}/>
                                <br/>
                                <Grid item xs={12} sm={12} container spacing={1} className={classes.paper}>
                                    <Grid item xs={2} sm={2}/>
                                    <Grid item xs={8} sm={8}>
                                        <Grid item xs={6} sm={6}>
                                            <QueueInfo total={queueList.length > 0 ? queueList.length - 1 : 0}/>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <div>

                                                {queueList.map((item, index) => {
                                                    if (index > 0 && index < 5) {
                                                        return (
                                                            <Fragment key={index}>
                                                                <QueueItem number={item} myTurn={item === myTurn}/>
                                                                <br/>
                                                            </Fragment>
                                                        )
                                                    }
                                                })}
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={2} sm={2}/>
                                </Grid>
                                <br/>
                                <QueueHeader number={myTurn} title={""} label={"Tu número"} myTurnStyle={true}/>
                            </Grid>
                        </Grid>

                        {/*
                            {representative.observer &&
                            <Link to={"/meeting/" + meeting.slug + "/search"}>
                                <Button variant="contained" color={"default"}>
                                    {getMessage(meeting.meeting_type, 'watch_attendance', messages)}
                                </Button>
                            </Link>
                            }
                            {(representative && meeting) && meeting.state !== 'finished' && !(meeting.zoom && meeting.zoom.is_integrated) && (meeting.video_conf_url || representative.video_conf_url) && (
                                <VideoConference
                                    messages={messages}
                                    url={representative.video_conf_url?representative.video_conf_url:meeting.video_conf_url}
                                    meeting={meeting}
                                    username={representative.data.name}
                                />
                            )}

                            <Switch>
                                <Route path="/meeting/:meeting_id/question/:question_id/answers" exact component={QuestionAnswers}/>
                                <Route path="/meeting/:meeting_id/question/:question_id" exact component={Question}/>
                                <Route path="/meeting/:meeting_id/search" exact >
                                    <MeetingSearch
                                        meeting={meeting}
                                        messages={messages}
                                    />
                                </Route>
                                <Route path="/meeting/:meeting_id/pending" exact component={PendingManualApprove}/>
                                <Route path="/meeting/:meeting_id" exact>
                                    <Meeting
                                        meeting={meeting}
                                        representative={representative}
                                        messages={messages}
                                    />
                                </Route>
                                <Route path="/meeting/:meeting_id/questions" exact component={MultipleQuestions}/>
                                <Route component={NotQuestionsFound}/>
                            </Switch>
                            */}
                        <Button variant="outlined" autoFocus onClick={removeFromQueue}>
                            Sacar de cola
                        </Button>
                        <Footer messages={messages} meeting={meeting}/>
                    </Fragment>
                ) : (
                    <Typography variant="h5" component="h2">
                        {getMessage('default', 'meeting_not_found', null)}
                    </Typography>
                )
            )
            }
        </Fragment>
    );
}

export default Main;
